import { FC } from "react";

import TiledImageHorizontal from "@/components/BentoList/TiledImageHorizontal";
import TiledText from "@/components/BentoList/TiledText";
import { BentoElement, BentoElementType, BentoTextElement, EditorialModuleImage } from "@/types";

const TiledBlockHWithImage: FC<{ items: BentoElement[] }> = ({ items }) => {
  return (
    <div className="grid grid-cols-2 gap-xs h-full">
      {items.map((item, index) => (
        <>
          {item.type === BentoElementType.image ? (
            <TiledImageHorizontal entry={item as EditorialModuleImage}></TiledImageHorizontal>
          ) : (
            item.type === BentoElementType.text && <TiledText slideIndex={index} entry={item as BentoTextElement} />
          )}
        </>
      ))}
    </div>
  );
};
export default TiledBlockHWithImage;
